import Base from 'netxcore@netx/core-category/collections/categories';

/** @override */
export default class Categories extends Base {
	/**
	 * @property {object} methods                      - Collection RPC methods
	 * @property {method} methods.read                 - Fetch categories
	 * @property {method} methods._getCategoriesByName - Fetch categories by name
	 */
	get methods() {
		return {
			...super.methods,
			/**
			 * @method
			 * @param {object} opts Request options
			 */
			read(opts) {
				if (this.currentCat) {
					this.parentid = parseInt(this.currentCat.get('categoryid'));
				}

				if (!this.parentid) {
					this.parentid = 1;
				}

				// get the categories from the DAM
				if (!this.cache) {
					return ['getCategories', this.searchString, this.parentid];
				}

				// Get the categories from our cache
				// Really this cache mechanism should be deprecated; I thought I did that, but no:
				// Netx.category.list still caches off of Netx.category.tree .  So this is a stopgap 'till we fix all that.
				return this.cache.fetchChildren(this.parentid).then((response) => {
					return this.cache.where({
						parentid: this.parentid,
					});
				});
			},
			/** @method */
			/** @TODO Move to core */
			_getCategoriesByName: ['getCategoryAutoList', 'searchString', 1],
		};
	}
}
